import Kr from 'Kr/kr';

//import Cursor from './app/modules/Cursor';
import 'KrComponent/ParallaxIt';

import 'KrComponent/IndividualLogos';
import 'KrComponent/IndividualImplementation';
import 'KrComponent/Tabs';
import 'KrComponent/Faq';
import 'KrComponent/IndividualImplementationTable';

import 'KrComponent/HomeSlider';
import 'KrComponent/HomeOpinionSlider';

import 'KrComponent/IndustryOpinionSlider';
import 'KrComponent/BSPMedia';



import BSIcons from './app/modules/BSIcons';

//import LinkClass from 'KrModule/LinkClass';

const app = new Kr.App
app.use('bs-icons', BSIcons);
app.run();
